import styled from 'styled-components';

export const EventItemList = styled.div`
  max-width: 40rem;
  overflow: auto;
  flex-grow: 1;
  width: 100%;
  height: calc(100vh - 10.5rem);
`;
